package com.nonopn.skywatcher.common.app.portfolio.main

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.AccountBox
import androidx.compose.material.icons.rounded.List
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.icons.Logout
import com.nonopn.skywatcher.common.app.drawer.DrawerItem
import com.nonopn.skywatcher.common.app.drawer.DrawerSeparator
import com.nonopn.skywatcher.common.app.drawer.DrawerTitle
import com.nonopn.skywatcher.common.app.drawer.systemBackground
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.navigation.RouterNoThunderDetectionSelected
import com.nonopn.skywatcher.common.app.navigation.RouterProfile
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_disconnect
import com.nonopn.skywatcher.common.app.res.menu_profile
import com.nonopn.skywatcher.common.app.res.menu_sentinels
import com.nonopn.skywatcher.common.app.res.menu_title_others
import com.nonopn.skywatcher.common.app.res.menu_title_sentinels
import com.nonopn.skywatcher.common.app.res.menu_title_user
import com.nonopn.skywatcher.config.SharedConfig
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.compose.widgets.spacers.BottomSpacer
import eu.codlab.compose.widgets.spacers.TopSpacer
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.RouteParameterTo

@Suppress("LongMethod", "UnusedPrivateMember")
@Composable
fun DrawerContentNoSelection(
    modifier: Modifier = Modifier,
    currentRoute: RouteParameterTo? = null,
    tiny: Boolean = false,
    onDisconnect: () -> Unit,
    onMenuItemSelected: (title: String, navigateTo: NavigateTo) -> Unit
) {
    val dark = LocalDarkTheme.current

    println("showing tiny ? $tiny")
    Column(
        modifier = modifier
            .systemBackground()
            .verticalScroll(rememberScrollState())
            .background(
                color = if (dark) {
                    AppColor.BackgroundBlue
                } else {
                    AppColor.White
                }
            )
    ) {
        TopSpacer()

        if (!tiny) {
            DrawerTitle(text = Res.string.menu_title_sentinels.localized())
        } else {
            // nothing
        }

        Res.string.menu_sentinels.localized().let { text ->
            DrawerItem(
                text = text,
                currentRoute = currentRoute,
                router = RouterNoThunderDetectionSelected,
                image = Icons.Rounded.List,
                onClick = {
                    onMenuItemSelected(
                        text,
                        RouterNoThunderDetectionSelected.navigateTo()
                    )
                },
                tiny = tiny
            )
        }

        DrawerSeparator(
            Modifier.padding(vertical = 16.dp)
        )

        if (!tiny) {
            DrawerTitle(text = Res.string.menu_title_user.localized())
        } else {
            // nothing
        }

        Res.string.menu_profile.localized().let { text ->
            DrawerItem(
                text = text,
                currentRoute = currentRoute,
                router = RouterProfile,
                image = Icons.Rounded.AccountBox,
                onClick = { onMenuItemSelected(text, RouterProfile.navigateTo()) },
                tiny = tiny
            )
        }

        DrawerSeparator(
            Modifier.padding(vertical = 16.dp)
        )

        Column(Modifier.weight(1.0f)) { }

        if (!tiny) {
            DrawerTitle(text = Res.string.menu_title_others.localized())
        } else {
            // nothing
        }

        DrawerItem(
            text = Res.string.menu_disconnect.localized(),
            currentRoute = currentRoute,
            router = null,
            image = Icons.Rounded.Logout,
            onClick = onDisconnect,
            tiny = tiny
        )

        Spacer(Modifier.height(8.dp))

        if (!tiny) {
            DrawerTitle(
                text = "v${SharedConfig.version}"
            )

            Spacer(Modifier.height(8.dp))
        }

        BottomSpacer()
    }
}

@HotPreview(widthDp = 300, heightDp = 900, darkMode = true)
@HotPreview(widthDp = 300, heightDp = 900, darkMode = false)
@Composable
private fun PreviewDrawerContent() {
    HotPreviewApp(
        isDarkTheme = isSystemInDarkTheme()
    ) {
        DrawerContentNoSelection(
            tiny = false,
            onDisconnect = {
                // nothing
            },
        ) { _, _ ->
            // nothing}
        }
    }
}
